import $ from 'jquery';

function BrowserCheck(element) {
  this.element = element;
  this.$element = $(element);
  this.init();
}

BrowserCheck.prototype = {
  init() {
    const browserArr = {};
    const uagent = navigator.userAgent.toLowerCase();
    let match = '';

    // console.log(`User agent string: ${uagent}`);

    browserArr.chrome = /webkit/.test(uagent) && /chrome/.test(uagent) && !/edge/.test(uagent);
    browserArr.firefox = /mozilla/.test(uagent) && /firefox/.test(uagent);
    browserArr.msie = /msie/.test(uagent) || /trident/.test(uagent) || /edge/.test(uagent);
    browserArr.safari = /safari/.test(uagent) && /applewebkit/.test(uagent) && !/chrome/.test(uagent);
    browserArr.opr = /mozilla/.test(uagent) && /applewebkit/.test(uagent) && /chrome/.test(uagent) && /safari/.test(uagent) && /opr/.test(uagent);
    browserArr.browser = '';
    browserArr.version = '';

    // console.log(Object.keys(browserArr).slice(0, -2));

    Object.keys(browserArr).slice(0, -2).forEach((key) => {
      if (browserArr[key]) {
        let matchCheck = '';

        if (key === 'msie') {
          matchCheck = 'msie|edge';
        } else if (key === 'safari') {
          matchCheck = 'version';
        } else {
          matchCheck = key;
        }

        match = uagent.match(new RegExp(`(${matchCheck})( |/)([0-9]+)`));
        browserArr.browser = key;

        if (match) {
          const newMatch = match[3];
          browserArr.version = newMatch;
        } else {
          match = uagent.match(new RegExp('rv:([0-9]+)'));
          browserArr.version = match ? match[1] : '';
        }
      }
    });

    $(document.body).addClass(`${browserArr.browser} ${browserArr.browser}-v${browserArr.version}`);

    browserArr.opera = browserArr.opr;
    delete browserArr.opr;
  },
};

export default BrowserCheck;
